import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { TextInput } from "./TextInput";
export const NumberInput = forwardRef(({ value, setValue, label, required, disabled, autoFocus, placeholder, helperText, className, allowNegative, decimalPlaces, error, }, ref) => {
    const setValueHandler = (e) => {
        if (decimalPlaces) {
            (new RegExp(`^${allowNegative ? "-?" : ""}\\d*(?:[.,])?(\\d{1,${decimalPlaces}})?$`).test(e) ||
                !e) &&
                setValue(e ? e.replaceAll(",", ".") : e);
        }
        else {
            (new RegExp(`^${allowNegative ? "-?" : ""}\\d*$`).test(e) || !e) && setValue(e);
        }
    };
    return (_jsx(TextInput, { ref: ref, value: value ? `${value}`.replaceAll(".", ",") : "", setValue: setValueHandler, label: label, required: required, disabled: disabled, placeholder: placeholder
            ? placeholder
            : decimalPlaces
                ? `0.${"0".repeat(decimalPlaces)}`
                : "0", inputProps: {
            className: "text-right",
            pattern: `^${allowNegative ? "-?" : ""}\\d+${decimalPlaces ? `(?:[.,])?(\\d{1,${decimalPlaces}})?` : ""}$`,
            lang: "sr-RS",
            inputMode: "numeric",
        }, className: className, autoFocus: autoFocus, helperText: helperText, error: error }));
});
